// src/utils/valut/valutApi.js
// Fetch wrappers for the customer-facing /valut endpoints.
// All return parsed JSON on 2xx, throw Error on non-2xx (caller handles).

import { API_URL } from "src/utils/apiUrl";
import { jsonOrThrow, authHeaders } from "src/utils/apiFetch";

export async function getCounts({ token }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/mine/counts`, {
        headers: authHeaders(token),
    });
    return jsonOrThrow(res);
}

export async function listMyRequests({ token, status, limit } = {}) {
    const qs = new URLSearchParams();
    if (status) qs.set("status", status);
    if (limit) qs.set("limit", String(limit));
    const url = `${API_URL}/api/pumppuRequests/mine${qs.toString() ? `?${qs}` : ""}`;
    const res = await fetch(url, { headers: authHeaders(token) });
    return jsonOrThrow(res);
}

export async function getRequest({ token, id }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/${id}`, {
        headers: authHeaders(token),
    });
    return jsonOrThrow(res);
}

export async function listOffers({ token, requestId }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/${requestId}/offers`, {
        headers: authHeaders(token),
    });
    return jsonOrThrow(res);
}

// Provider companies that declined this request (name + optional reason), so the
// customer sees their request isn't a black box. Returns [] on a fresh request.
export async function listDeclinedProviders({ token, requestId }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/${requestId}/declined-providers`, {
        headers: authHeaders(token),
    });
    return jsonOrThrow(res);
}

// Provider companies that have opened this request's detail (open-details
// model: viewing reveals the customer's contact info, so the customer sees
// who looked). Returns [] on a fresh request.
export async function listViewers({ token, requestId }) {
    const res = await fetch(`${API_URL}/api/pumppuRequests/${requestId}/viewers`, {
        headers: authHeaders(token),
    });
    return jsonOrThrow(res);
}

export async function acceptOffer({ token, requestId, offerId }) {
    const res = await fetch(
        `${API_URL}/api/pumppuRequests/${requestId}/offers/${offerId}/accept`,
        { method: "POST", headers: authHeaders(token) },
    );
    return jsonOrThrow(res);
}
